<template>
	<!-- progress bar -->
	<div v-if="apMetaStats.starsAverage > 0" class="d-flex">
		<p class="m-0 text-center">
			<span :class="'text-' + apMetaStats.color">
				<strong>&nbsp;{{apMetaStats.starsAverage}}&nbsp;</strong>
				<font-awesome-icon :icon="['fas', 'star']" />
			</span>
		</p>
		<b-progress v-if="isBarVisible" height="1.5rem" show-progress class="ml-5 flex-grow-1">
			<b-progress-bar
				:max="apMetaStats.noOfQuestions"
				:value="apMetaStats.summedValues"
				:variant="apMetaStats.color"
			>
				<span>
					<em>{{apMetaStats.percentage}}%</em>
				</span>
			</b-progress-bar>
		</b-progress>
	</div>
</template>
<script>
	export default {
		// the average closure-questions stars + bar graph with percentage
		name: "closureQuestionStarStatBar_component",
		props: {
			apMetaStats: {
				type: Object,
				default: () => ({})
			},
			isBarVisible: {
				type: Boolean,
				default: () => true
			}
		}
	};
</script>